<template>
  <div>
    <users-form
      v-if="showForm"
      ref="refUsersForm"
       :groups-info="groupsInfo"
      :item-data="itemData"
    />

    <users-password
      v-if="showFormPassword"
      ref="refUsersPassword"
      :hanwha-dvr="hanwhaDvr"
      :item-data-password="itemDataPassword"
    />

    <users-list
      v-if="!showForm && !showFormPassword"
      :hanwha-dvr="hanwhaDvr"
      :loading="loading"
      :users-info="usersInfo"
      @change-user-password="changeUserPassword"
      @edit="edit"
      @refresh="getUsers()"
      @show-form="create()"
    />

    <div class="text-right">
      <!-- Form User buttons -->
      <b-button
        v-if="showForm"
        class="text-capitalize mr-1"
        variant="secondary"
        :disabled="loading"
        @click="showForm = false"
      >
        {{ $t('actions.cancel') }}
      </b-button>
      <b-button
        v-if="showForm"
        variant="primary"
        :disabled="loading"
        @click="saveUser"
      >
        {{ buttonSubmitText }}
      </b-button>
      <!-- Change password buttons -->
      <b-button
        v-if="showFormPassword"
        class="text-capitalize"
        variant="secondary"
        :disabled="loading"
        @click="showFormPassword = false"
      >
        {{ $t('actions.cancel') }}
      </b-button>
      <b-button
        v-if="showFormPassword"
        class="text-capitalize"
        variant="primary"
        :disabled="loading"
        @click="changePassword"
      >
        {{ $t('actions.accept') }}
      </b-button>
    </div>

  </div>
</template>

<script>
import { BModal, BSpinner } from "bootstrap-vue";
import { computed, ref, onMounted } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import axios from "@axios";
import vSelect from "vue-select";
import SkeletonLoading from "@/components/SkeletonLoading.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import UsersForm from "./UsersForm.vue";
import UsersList from "./UsersList.vue";
import UsersPassword from "./UsersPassword.vue";

export default {
  components: {
    BModal,
    BSpinner,
    vSelect,
    SkeletonLoading,
    UsersForm,
    UsersList,
    UsersPassword
  },
  props: {
    hanwhaDvr: { type: Object, require: true },
  },
  setup(props, { emit }) {
    //HOOKS
    onMounted(async () => {
      await getGroups();
      await getUsers();
    });

    //COMPOSABLES
    const toast = useToast();

    //DATA
    const groupsInfo = ref([]);

    const loading = ref(false);

    const itemData = ref({
      user_id: null,
      user_name: null,
      group_id: 'Prueba',
      viewer_access: false,
      user_level: null,
      password: null,
      isEdit: false
    });

     const itemDataPassword = ref({
      user_id: null,
      current_password: null,
      new_password: null,
      confirm_new_password: null,
      rsa_key: null,
      id_dvr: null
    });

    const refUsersForm = ref(null);

    const refUsersPassword = ref(null);

    const showForm = ref(false);

    const showFormPassword = ref(false);

    const usersInfo = ref([]);

    //COMPUTED
    const buttonSubmitText =  computed(() => (itemData.value.isEdit) ? 'Editar' : 'Guardar');

    //METHODS
    const changePassword = async() => {
      const isValid = await refUsersPassword.value.validateStep();

      if (!isValid) {
        return;
      }

      showForm.value = false;
      loading.value  = true;

      itemDataPassword.value.id_dvr = props.hanwhaDvr.id

      await axios.post('/v1/hanwha/dvr/admin/users/change-password', itemDataPassword.value)
        .then(response => {
          const { data } = response;

          console.log('data', data);
        })
        .catch(error => {
          usersInfo.value = [];
        })
        .finally(() => {
          loading.value = false;
        });
    }

    const changeUserPassword = (user) => {
      showFormPassword.value = true;
      itemDataPassword.value.user_id = user.UserName;
    }

    const create = () => {
      showForm.value = true;
      showFormPassword.value = false;

      itemData.value = {
        user_id: null,
        user_name: null,
        group_id: 'Prueba',
        viewer_access: false,
        user_level: 'User',
        password: null,
        isEdit: false
      }
    }

    const edit = (user) => {
      itemData.value.group_id      = user.GroupID;
      itemData.value.user_id       = user.UserID;
      itemData.value.user_level    = user.UserLevel;
      itemData.value.user_name     = user.UserName;
      itemData.value.viewer_access = user.ViewerAccess;
      itemData.value.password      = null;
      itemData.value.isEdit        = true;

      showForm.value = true;
      showFormPassword.value = false;
    }

    async function fetchData(params) {
      return await axios.post('/v1/hanwha/dvr/admin/users', params);
    }

    const getGroups = async () => {
      const params = {
        action: 'read-groups',
        id_dvr: props.hanwhaDvr.id,
        params: {}
      }

      showForm.value = false;
      loading.value  = true;

      await fetchData(params)
        .then(response => {
          const { data } = response;

          groupsInfo.value = data.data.UserGroups;
        })
        .catch(error => {
          groupsInfo.value = [];
        })
        .finally(() => {
          loading.value = false;
        });
    }

    const getUsers = async () => {
      const params = {
        action: 'read',
        id_dvr: props.hanwhaDvr.id,
        params: {}
      }

      showForm.value = false;
      loading.value  = true;

      await fetchData(params)
        .then(response => {
          const { data } = response;

          usersInfo.value = data.data.Users;
        })
        .catch(error => {
          usersInfo.value = [];
        })
        .finally(() => {
          loading.value = false;
        });
    }

    const saveUser = async () => {
      const isValid = await refUsersForm.value.validateStep();

      if (!isValid) {
        return;
      }

      const params = {
        action: (itemData.value.isEdit) ? 'update' : 'create',
        id_dvr: props.hanwhaDvr.id,
        params: itemData.value
      }

      loading.value = true;

      await fetchData(params)
        .then(response => {
          const { data } = response;

          if (data.data.Response === 'Fail') {
            const { Code,Details } = data.data.Error;

            toast({
              component: ToastificationContent,
              props: {
                title: "Validation error",
                text: `${Code} - ${Details}`,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });

            loading.value = false;

            return;
          }

          toast({
              component: ToastificationContent,
              props: {
                title: 'Ok',
                text: data.data.Response,
                icon: "CheckIcon",
                variant: "success",
              },
            });

          loading.value = false;
         (async () => await getUsers())();
        })
        .catch(error => {
          loading.value = false;
        });
    }

    return {
      groupsInfo,
      loading,
      itemData,
      itemDataPassword,
      refUsersForm,
      refUsersPassword,
      showForm,
      showFormPassword,
      usersInfo,

      buttonSubmitText,

      changePassword,
      changeUserPassword,
      create,
      edit,
      getUsers,
      saveUser
    };
  },
};
</script>

<style lang="scss" scoped>
.diskInfoDetailKey {
  width: 140px;
  font-weight: 100;
  color: #a5a5a5;
}
.diskInfoDetailItem {
  color: #393735;
}
.dark-layout {
  .diskInfoDetailKey {
    color: #a5a5a5;
  }
  .diskInfoDetailItem {
    color: #fff;
  }
}
</style>
